import { render, staticRenderFns } from "./DiscoverBody.vue?vue&type=template&id=01d5171e&scoped=true&"
import script from "./DiscoverBody.vue?vue&type=script&lang=js&"
export * from "./DiscoverBody.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverBody.vue?vue&type=style&index=0&id=01d5171e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5171e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
